(function () {

    'use strict';

    angular.module('iplusjs.integration.pksregister', [
        'iplusjs.config',
        'iplusjs.fieldset',
        'iplusjs.authentication',
        'iplusjs.integration',
        'iplusjs.utils.misc',
        'iplusjs.utils.misc',
        'iplusjs.button.btn',
        'iplusjs.validator.form',
        'iplusjs.utils.formField',
        'iplusjs.utils.identityType',
        'iplusjs.validator.isEqualTo',
        'iplusjs.loadingIndicator',
        'iplusjs.alert.service',
        'lodash',
        'modernizr'
    ])
        .component('iplusjsPksRegister', {
            bindings: {
                data: '<iprData',
                options: '<iprOptions'
            },
            templateUrl: 'common/integration/pksRegister.html',
            controller: PksRegisterController,
            controllerAs: 'pksVm'
        })
        .service('PksRegisterService', PksRegisterService);

    PksRegisterController.$inject = [
        '$scope',
        '$log',
        '$window',
        '$q',
        'lodash',
        'modernizr',
        'AppConfig',
        'FormFieldUtilsService',
        'PksRegisterService',
        'MiscUtilsService',
        'LoadingIndicatorService',
        'AuthenticationService',
        'AlertService',
        'FormatUtilsService',
        'IdentityTypeUtilsService'
    ];

    function PksRegisterController($scope, $log, $window, $q, _, modernizr, AppConfig, FormFieldUtilsService, PksRegisterService, MiscUtilsService, LoadingIndicatorService, AuthenticationService, AlertService, FormatUtilsService, IdentityTypeUtilsService) {
        var vm = this,
            redirectUrl,
            navigateToUrl;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.register = register;
        vm.isVisible = isVisible;
        vm.isFieldDisabled = isFieldDisabled;
        vm.isPasswordStrengthErlaubt = isPasswordStrengthErlaubt;
        vm.checkPasswordSecurity = checkPasswordSecurity;
        vm.togglePasswordVisibility = togglePasswordVisibility;

        function onInit() {
            vm.disabled = {
                benutzername: true
            };
            setPasswordStrength(null);
            activate();
        }

        function onChanges() {
            activate();
        }

        function activate() {
            vm.registerModel = {
                benutzername: _.get(vm.data, 'benutzername'),
                partnernummer: _.get(vm.data, 'partnernummer'),
                neukundeToken: _.get(vm.data, 'neukundeToken'),
                angebotsnummer: _.get(vm.data, 'angebotsnummer'),
                angebotstoken: _.get(vm.data, 'angebotstoken'),
                emailPrivat: _.get(vm.data, 'emailPrivat'),
                epost: true
            };

            redirectUrl = AppConfig.APP.urls.kundenportalStartseite;

            if (_.size(_.get(vm.data, 'vertragsnummer')) > 0) {
                if (_.size(_.get(vm.data, 'vertragsnummer')) === 1) {
                    vm.registerModel.vertragsnummer = IdentityTypeUtilsService.toId(_.get(vm.data, 'vertragsnummer[0]'), 'VERTRAGSNUMMER') || _.get(vm.data, 'vertragsnummer[0]');

                    redirectUrl = FormatUtilsService.replace(AppConfig.APP.urls.kundenportalVertragDetails, vm.registerModel.vertragsnummer);
                } else {
                    redirectUrl = AppConfig.APP.urls.kundenportalVertraege;
                }
                navigateToUrl = _.replace(redirectUrl, AppConfig.APP.urls.homepage, '');
            }

            vm.linkPksAppStore = AppConfig.APP.urls.appStoreLinks;
        }

        function register() {
            FormFieldUtilsService.validate(vm.pksRegisterForm, /./, {
                setIsSubmitted: true,
                setTouched: true
            });

            AlertService.removeById(/^PKSREGISTER/);

            if (!vm.pksRegisterForm.$valid && !vm.pending) {
                vm.registerModel.registerStatus = null;
                vm.pending = false;
                return false;
            }

            LoadingIndicatorService.addInProgress();
            vm.pending = true;

            PksRegisterService.register(vm.registerModel).then(function (data) {
                $log.log('SUCCESS register', data);
                vm.registerModel.registerStatus = 'SUCCESS';

                return $q(function (resolve, reject) {
                    PksRegisterService.login(vm.registerModel).then(function (data) {
                        data.username = vm.registerModel.benutzername;

                        if (modernizr.localstorage) {
                            $window.localStorage.removeItem('motherSessions');
                            $window.localStorage.setItem('loginUser', JSON.stringify(data));
                        }
                        resolve();
                    }).catch(function (error) {
                        redirectUrl = AppConfig.APP.urls.kundenportalInfo;
                        if (modernizr.sessionstorage && navigateToUrl) {
                            $window.sessionStorage.setItem('navigateToUrl', navigateToUrl);
                        }
                        resolve();
                    });
                }).finally(function () {
                    vm.registerModel = {
                        registerStatus: 'SUCCESS'
                    };

                    vm.data = {
                        isVisible: true
                    };
                    $window.removePksRedirectInfos = false;
                    $window.confirmBeforeUnload = false;
                    $window.parent.location.href = redirectUrl;
                });
            }).catch(function (error) {
                error = error || {};

                var message;

                $log.log('FAILURE register', error);
                vm.registerModel.registerStatus = 'FAILURE';

                if (error === 'NICHT_ALLE_DATEN_VORHANDEN') {
                    $scope.$emit('iplusjs:createAndAddAlert', {
                        message: AppConfig.MESSAGES.notAllDataExists,
                        type: 'alert',
                        id: 'PKSREGISTER_NOT_ALL_DATA'
                    });
                    return;
                }

                if (error.id === 'BENUTZERNAME') {
                    _.set(vm.disabled, 'benutzername', false);
                }

                if (_.includes([
                    'KENNWORT',
                    'BENUTZERNAME',
                    'PERMISSION_FAIL'
                ], error.id)) {
                    message = error.message;
                }

                if (message) {
                    $scope.$emit('iplusjs:createAndAddAlert', {
                        message: message,
                        type: 'alert',
                        id: ['PKSREGISTER', error.id].join('_')
                    });
                } else {
                    $scope.$emit('iplusjs:createAndAddAlert', {
                        message: AppConfig.MESSAGES.unexpected,
                        type: 'alert',
                        id: 'PKSREGISTER_UNEXPECTED'
                    });
                }

            }).finally(function () {
                vm.pending = false;
                LoadingIndicatorService.removeInProgress();
            });
        }

        function isVisible() {
            return (
                _.get(vm.data, 'isVisible') &&
                !AuthenticationService.isTokenLogin() &&
                vm.registerModel.registerStatus !== 'SUCCESS'
            );
        }

        function isFieldDisabled(field) {
            if (field === 'benutzername') {
                return vm.disabled.benutzername;
            }
        }

        function isPasswordStrengthErlaubt() {
            if (!vm.pksRegisterForm) {
                return false;
            }

            return !!(
                _.get(vm.pksRegisterForm, 'passwort.$dirty')
            );
        }
        function checkPasswordSecurity() {
            PksRegisterService.checkPasswordSecurity(vm.registerModel).then(function (data) {
                setPasswordStrength(data);
            }).catch(function (error) {
                setPasswordStrength(null);
            });
        }
        function togglePasswordVisibility($event, form, fieldName) {
            if (!fieldName || !$event || !form) {
                return;
            }

            var inputElement = _.get(form, fieldName + '.$$element[0]'),
                $visibilityElement = angular.element($event.target);

            if (!inputElement) {
                return;
            }

            if (inputElement.type === 'password') {
                inputElement.type = 'text';
                $visibilityElement.removeClass('visibility');
                $visibilityElement.addClass('visibility-off');
            } else {
                inputElement.type = 'password';
                $visibilityElement.removeClass('visibility-off');
                $visibilityElement.addClass('visibility');
            }
        }
        function setPasswordStrength(data) {
            data = data || {};

            if (data.color === 'RED' || MiscUtilsService.isAtLeastOneEmpty(data, data.color)) {
                vm.passwordStrengthColor = 'red';
                vm.passwordStrengthText = 'Unsicher';
                vm.passwordStrengtProcessStyle = {
                    width: '25%'
                };
            } else if (data.color === 'YELLOW') {
                vm.passwordStrengthColor = 'green';
                vm.passwordStrengthText = 'Sicher';
                vm.passwordStrengtProcessStyle = {
                    width: '75%'
                };

            } else if (data.color === 'GREEN') {
                vm.passwordStrengthColor = 'green';
                vm.passwordStrengthText = 'Sehr sicher';
                vm.passwordStrengtProcessStyle = {
                    width: '100%'
                };
            }
        }
    }

    PksRegisterService.$inject = [
        '$q',
        '$http',
        '$httpParamSerializerJQLike',
        '$analytics',
        'lodash',
        'AppConfig',
        'IntegrationService',
        'FormatUtilsService',
        'MiscUtilsService'
    ];

    function PksRegisterService($q, $http, $httpParamSerializerJQLike, $analytics, _, AppConfig, IntegrationService, FormatUtilsService, MiscUtilsService) {
        var that = this;

        that.register = register;
        that.login = login;
        that.checkPasswordSecurity = checkPasswordSecurity;
        function register(registerModel) {
            var externalSid = IntegrationService.getExternalSid(),
                serviceUrl = FormatUtilsService.replace(AppConfig.INTEGRATION.services.kundenportalRegister, externalSid);

            registerModel = registerModel || {};

            if (MiscUtilsService.isAtLeastOneEmpty(serviceUrl, registerModel.benutzername, registerModel.passwort, registerModel.neukundeToken, registerModel.angebotsnummer, registerModel.angebotstoken, registerModel.partnernummer)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            $analytics.eventTrack('link', {
                target: 'Kundenportal-register'
            });

            return $http({
                method: 'POST',
                url: serviceUrl,
                data: $httpParamSerializerJQLike({
                    p_ang_nummer: registerModel.angebotsnummer,
                    p_ang_token: registerModel.angebotstoken,
                    p_par_nummer: registerModel.partnernummer,
                    p_par_token: registerModel.neukundeToken,
                    p_user: registerModel.benutzername,
                    p_pw: registerModel.passwort,
                    p_email_adr: registerModel.emailPrivat,
                    p_epost_knz: registerModel.epost ? 'J' : 'N'
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                cache: false,
                globalErrorsIgnore: {
                    errors: true,
                    nachrichten: true
                },
                httpErrorsIgnore: true,
                unexpectedErrorsIgnore: true
            }).then(function (response) {
                var result = _.get(response.data, 'result') || {};

                if (result.fehler) {
                    return $q.reject({
                        id: _.get(result.fehler, 'fehlercode'),
                        message: _.get(result.fehler, 'fehlermeldung')
                    });
                }

                return result;
            });
        }
        function login(registerModel) {
            var serviceUrl = AppConfig.INTEGRATION.services.kundenportalLogin;

            registerModel = registerModel || {};

            if (MiscUtilsService.isAtLeastOneEmpty(serviceUrl, registerModel.benutzername, registerModel.passwort) || registerModel.registerStatus !== 'SUCCESS') {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http({
                method: 'POST',
                url: serviceUrl,
                data: $httpParamSerializerJQLike({
                    p_user: registerModel.benutzername,
                    p_pw: registerModel.passwort,
                    p_modus: 'ICPAR',
                    p_anzahl: 5
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                cache: false,
                globalErrorsIgnore: {
                    errors: true,
                    nachrichten: true
                },
                httpErrorsIgnore: true,
                unexpectedErrorsIgnore: true
            }).then(function (response) {
                var result = _.get(response.data, 'result') || {};

                if (result.cause !== 'AUTHENTICATION_SUCCESS') {
                    return $q.reject({
                        id: _.get(result, 'code'),
                        message: _.get(result, 'message')
                    });
                }

                return result;
            });
        }
        function checkPasswordSecurity(registerModel) {
            var externalSid = IntegrationService.getExternalSid(),
                serviceUrl;

            if (externalSid) {
                serviceUrl = FormatUtilsService.replace(AppConfig.INTEGRATION.services.checkPasswordSecurity, externalSid);
            } else {
                serviceUrl = AppConfig.INTEGRATION.services.checkPasswordSecurityWithoutSid;
            }

            registerModel = registerModel || {};

            if (MiscUtilsService.isAtLeastOneEmpty(serviceUrl, registerModel.benutzername, registerModel.passwort)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http({
                method: 'POST',
                url: serviceUrl,
                data: $httpParamSerializerJQLike({
                    p_user: registerModel.benutzername,
                    p_pw_neu: registerModel.passwort
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                cache: false,
                globalErrorsIgnore: {
                    errors: true,
                    nachrichten: true
                },
                httpErrorsIgnore: true,
                unexpectedErrorsIgnore: true
            }).then(function (response) {
                var result = _.get(response.data, 'result') || {};

                if (result.fehler) {
                    return $q.reject(_.get(result.fehler, 'fehlermeldung'));
                }

                return {
                    color: _.get(result.pwcheck, 'farbe') || 'red'
                };
            });
        }
    }

})();
